import { Wrench, Sparkles, Printer, UserCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TrustBar() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  // Kevin 05.11.2026: Firmen haben keine Druckflatrate (150 inklusive, mehr zubuchbar)
  const isBusiness = pathname.startsWith("/businesskunden") || (pathname.startsWith("/buchen") && params.get("type") === "business");
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 30);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  const ITEMS = [
    { icon: Wrench, label: t("trustbar.setup") },
    { icon: Sparkles, label: t("trustbar.premium") },
    { icon: Printer, label: isBusiness ? "Kauf auf Rechnung" : t("trustbar.printflat") },
    { icon: UserCheck, label: t("trustbar.contact") },
  ];

  // Hide on splash home and admin
  if (pathname === "/" || pathname.startsWith("/admin")) return null;

  return (
    <div
      className={`fixed left-0 right-0 z-40 transition-all duration-500 border-b border-cream/[0.06] bg-ink-900/85 backdrop-blur-md py-2.5 hidden md:block ${
        scrolled ? "top-[60px]" : "top-[80px] md:top-[92px]"
      }`}
      data-testid="trust-bar"
    >
      <div className="container-x">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-cream/70">
          {ITEMS.map((it) => (
            <div key={it.label} className="flex items-center gap-2 text-[0.68rem] uppercase tracking-[0.28em]">
              <it.icon className="h-3.5 w-3.5 text-gold" strokeWidth={1.5} />
              <span>{it.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

